// extracted by mini-css-extract-plugin
export default {"GameHeader":"GameHeader_GameHeader__nT2hZ"};